var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPosIcon = function SvgPosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#5F6A7D",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3v2h1a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h1v-2h-3a2 2 0 0 1-2-2zm7 12h2v-2h-2zm7-4H10v-8h12z",
    clipRule: "evenodd"
  })));
};
export { SvgPosIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHJ4PSI2IiBmaWxsPSIjNUY2QTdEIi8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDEwQzggOC44OTU0MyA4Ljg5NTQzIDggMTAgOEgyMkMyMy4xMDQ2IDggMjQgOC44OTU0MyAyNCAxMFYxOEMyNCAxOS4xMDQ2IDIzLjEwNDYgMjAgMjIgMjBIMTlWMjJIMjBDMjAuNTUyMyAyMiAyMSAyMi40NDc3IDIxIDIzQzIxIDIzLjU1MjMgMjAuNTUyMyAyNCAyMCAyNEgxOEgxNEgxMkMxMS40NDc3IDI0IDExIDIzLjU1MjMgMTEgMjNDMTEgMjIuNDQ3NyAxMS40NDc3IDIyIDEyIDIySDEzVjIwSDEwQzguODk1NDMgMjAgOCAxOS4xMDQ2IDggMThWMTBaTTE1IDIySDE3VjIwSDE1VjIyWk0yMiAxOEgxOEgxNEgxMFYxMEwyMiAxMFYxOFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";